import React, { Component } from "react";
import { connect } from "react-redux";
import M from "materialize-css/dist/js/materialize.min.js";
import PropTypes from "prop-types";
import { removeWallet } from "../../actions/passport/set";
import "./modal.css";
import $ from "jquery";
import Loader from './loader';

class Modal extends Component {
  static contextTypes = {
    router: PropTypes.object
  };
  render() {
    let {
      id,
      classes,
      title,
      decryption,
      isOrder,
      buttonText,
      noDescriptionText,
      component,
      logout,
      chain,
      buttonText2,
      buttonAction,
      buttonAction2,
      style = {},
      noClose,
      noIcon,
      confirmPass,
      closeAction,
      note,
      passwordId
    } = this.props;
    let buttonClass = "waves-effect black-text btn-flat left";
    if (!noClose) buttonClass += " modal-close";

    return (
      <div id={id} className={classes} style={style}>
        {!noIcon && noClose && !closeAction && (
          <span id="closeModal" className="modal-close">
            <i className="material-icons greyOut">
              close
            </i>
          </span>
        )}

        {!noIcon && noClose && closeAction && (
          <a
            id="closeModal"
            onClick={this.close.bind(this)}
            className="modal-close"
          >
            <i className="material-icons greyOut" >
              close
            </i>
          </a>
        )}

        {title && (
          <h4 className="black-text">
            {title}
          </h4>
        )}

        <div className="modal-content" style={{paddingTop:'0px'}}>
          {component}

        </div>
        {(buttonText || buttonText2 || logout || this.props.loading) && (
          <div className="modal-footer">
            <div className='row' style={{paddingLeft:'12px',paddingRight:'12px',paddingTop:'5px',paddingBottom:'5px'}}>
            <div className="col s12">
              {decryption && this.passwordInput(passwordId ? passwordId : "password",confirmPass ? 'Create Pin' : 'Pin')}

              {decryption && confirmPass && this.passwordInput(passwordId ? `${passwordId}Confirm` : "passwordConfirm",'Confirm Pin')}


              {(this.props.loading === true || (this.props.title === 'Connection Settings' && this.props.loading === 'automatic')) ? <Loader/> : buttonText && (
                <button onClick={this.onSubmit.bind(this)} style= {{marginTop:confirmPass ? '10px' : '',float:'left',width:'fit-content',padding:'5px',paddingLeft:'10px',paddingRight:'10px'}} className="btn clickablesBlack2">{buttonText}
                </button>
              )}

              {buttonText2 && buttonAction2 && (
                <button onClick={this.onSubmit2.bind(this)} style= {{float:'right',width:'fit-content',padding:'5px',paddingLeft:'10px',paddingRight:'10px'}} className="btn clickablesBlack2">{buttonText2}</button>
              )}

              {logout && (
                <button onClick={this.removeWallet.bind(this)} style= {{float:'right',width:'fit-content',padding:'5px',paddingLeft:'10px',paddingRight:'10px'}} className="btn clickablesBlack2">LOG OUT</button>
              )}
            </div>

            {note && (
              <div className="col s12">
                <p style={{ fontSize: "10px", height: "10px", textAlign: "left",marginBottom:'5px'}}>
                  {note}
                </p>
              </div>
            )}
            </div>
          </div>
        )}
      </div>
    );
  }
  passwordInput(passwordId,placeholder){
    return (
      <div className='col s6' style={{padding:0}}>
        <form
          onSubmit={this.onSubmit.bind(this)}
          autoComplete="off"
          style={{textAlign:'left',paddingRight:'20px',fontSize:'12px' }}
        >
          <input
            id={passwordId}
            placeholder={placeholder}
            className="blacktext passwordClass"
            type="password"
            required={true}
          />
        </form>
      </div>
    )
  }
  isOrder() {
    return (
      <div className="col s12">
        <p
          className="grey-text"
          style={{ display: "inline", fontSize: "12px" }}
        >
          *Your transaction may not go through depending on other transactions
          being sent on the network.
        </p>
        <br />
        {this.props.sendsFromChain.toUpperCase() === "NRG" ||
        this.props.receivesToChain.toUpperCase() === "NRG" ? (
          <p
            className="grey-text"
            style={{ display: "inline", fontSize: "12px" }}
          >
            **This is the fee the taker must pay you in order to take this
            complete order.
          </p>
        ) : null}
        {this.props.sendsFromChain.toUpperCase() === "DAI" ||
        this.props.receivesToChain.toUpperCase() === "DAI" ||
        this.props.sendsFromChain.toUpperCase() === "USDT" ||
        this.props.receivesToChain.toUpperCase() === "USDT" ? (
          <p
            className="grey-text"
            style={{ display: "inline", fontSize: "12px" }}
          >
            **NOTE: If you are trading with an ERC-20 token, like USDT or DAI,
            you will need to have some ETH at that address for the network fees
            (gas).
          </p>
        ) : null}
      </div>
    );
  }
  close(event) {
    if (this.props.passwordId && $(`#${this.props.passwordId}`)) {
      $(`#${this.props.passwordId}`).value = "";
    }
    if (this.props.passwordId && $(`#${this.props.passwordId}Confirm`)) {
      $(`#${this.props.passwordId}Confirm`).value = "";
    }
    if ($("#password")) {
      $(`#password`).value = "";
    }
    if ($("#passwordConfirm")) {
      $(`#passwordConfirm`).value = "";
    }
    this.props.closeAction();
    if (event && event.preventDefault) event.preventDefault();
  }
  onSubmit2(event) {
    this.props.buttonAction2();
    if (event && event.preventDefault) event.preventDefault();
  }
  onSubmit(event) {
    this.props.buttonAction();
    if (event && event.preventDefault) event.preventDefault();
  }
  removeWallet() {
    this.props.removeWallet();
    window.location.reload()
  }
  componentDidMount() {
    let elems = document.querySelectorAll(`#${this.props.id}`);
    if (elems)
      M.Modal.init(elems, {
        dismissible: false,
        inDuration: 0,
        outDuration: 0,
        onCloseEnd: () => {
          $('.modal :input').val('');
        }
      });
  }
}

// {decryption && !noDescriptionText && <p className="black-text" style={{marginBottom:0}}>Enter Password:</p>}

function mapStateToProps(state, props) {
  let { denomination, asset, type } = state.ui_marketplace.market;
  let sendsFromChain =
    state.ui_marketplace.orderType === "BUY" ? denomination : asset;
  let receivesToChain =
    state.ui_marketplace.orderType === "BUY" ? asset : denomination;
  return {
    sendsFromChain,
    receivesToChain,
    loading: state.ui_passport.loading
  };
}

export default connect(
  mapStateToProps,
  { removeWallet }
)(Modal);
